module.exports = __webpack_public_path__ + "static/media/cardHeader.d2851251.jpeg";